import { PublicationStatus } from './types';
import { type PublicationPayload } from '../../../graphql';
import {
  type FormController,
  FormModificationMode,
} from '../../../../../utils';

export type PublicationControl = Record<keyof PublicationPayload, boolean> & {
  enableSave: boolean;
  enableDelete: boolean;
};

export type PublicationFieldPermissions = Omit<
  PublicationControl,
  'publicationId'
>;

export const editPublicationPermission = (
  initialValues: PublicationPayload,
  formikValues: PublicationPayload,
  enableEditCondition: FormController,
): PublicationFieldPermissions => {
  const { formModificationMode } = enableEditCondition;
  // Academic qualification form field permissions
  const disablePublicationFieldPermissions: PublicationFieldPermissions = {
    publicationType: false,
    otherType: false,
    publicationAuthors: false,
    publicationTitle: false,
    publicationName: false,
    applicantRole: false,
    specificRole: false,
    publicationStatus: false,
    publicationDate: false,
    issuePageArticelNo: false,
    peerReviewedIndicator: false,
    citationInfo: false,
    publicationUrl: false,
    supportingDocuments: false,
    enableSave: false,
    enableDelete: false,
  };

  const enablePublicationFieldPermissions: PublicationFieldPermissions = {
    ...Object.assign(
      {},
      ...Object.keys(disablePublicationFieldPermissions).map(key => ({
        [key]: true,
      })),
    ),
  };

  const modifyPublicationFieldPermissions: PublicationFieldPermissions = {
    ...disablePublicationFieldPermissions,
    ...(initialValues.publicationStatus !== PublicationStatus.PUBLISHED && {
      publicationStatus: true,
      publicationDate: true,
      issuePageArticelNo: true,
      peerReviewedIndicator: true,
      citationInfo: true,
      publicationUrl: true,
      enableSave: true,
    }),
  };

  const PublicationPermission: Record<
    FormModificationMode,
    PublicationFieldPermissions
  > = {
    [FormModificationMode.ENABLE]: enablePublicationFieldPermissions,
    [FormModificationMode.DISABLE]: disablePublicationFieldPermissions,
    [FormModificationMode.MODIFIED_ONLY]: modifyPublicationFieldPermissions,
    [FormModificationMode.CONDITION_MEET]: disablePublicationFieldPermissions,
  };

  return PublicationPermission[formModificationMode];
};
